import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { PitchFormData } from "../../../components/Models/PitchFormData";
import { PitchTeamData } from "../../../components/Models/PitchTeamData";

interface UseGetPitchProps {
  id: string;
  enabled?: boolean;
}

export interface PitchByUserItem {
  pitch: PitchFormData;
  teamMembers: PitchTeamData[];
  files: {
    item1: File[];
    item2: File[];
  };
}

interface PitchesByUserResponse {
  pitches: PitchByUserItem[];
}

export function useGetPitchesByUser({ id, enabled = true }: UseGetPitchProps) {
  return useQuery({
    enabled,
    queryKey: ["user-pitches", id],
    queryFn: async () => {
      try {
        const response = await axiosInstance<PitchesByUserResponse>(
          getAPIURL(`/Pitch/get-pitch-by-createdBy/${id}`)
        );
        return response.data;
      } catch (error: any) {
        const status = error?.response?.status;

        if (status === 404) {
          return { pitches: [] };
        }

        throw error;
      }
    },
    retry: (failureCount, error: any) => {
      const status = error?.response?.status;
      // Do not retry for client errors
      return status !== 400 && failureCount < 3;
    },
  });
}
